module.exports = __webpack_public_path__ + "videos/splash-1.f59b3a5.mp4";